// extracted by mini-css-extract-plugin
module.exports = {"success":"success__2GoNn","title":"title__2Ta_G","text":"text__vYIdy"};